import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { cognitoApi, generalApi } from '../services/api';

export const store = configureStore({
  reducer: {
    [cognitoApi.reducerPath]: cognitoApi.reducer,
    [generalApi.reducerPath]: generalApi.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(cognitoApi.middleware, generalApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
